export default __webpack_public_path__ + "static/favicon-dfab4ca09bd7ef6f55e83183c4c65eef.ico";